module.exports = __webpack_public_path__ + "img/safe.1868f828.png";